import { render, staticRenderFns } from "./PlayerDesktop.vue?vue&type=template&id=ef0169a6&lang=pug&"
import script from "./PlayerDesktop.vue?vue&type=script&lang=js&"
export * from "./PlayerDesktop.vue?vue&type=script&lang=js&"
import style0 from "./PlayerDesktop.vue?vue&type=style&index=0&module=true&lang=postcss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports